import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'

export default function Tooltip({ children, text }) {
  if (!text) {
    return children
  }

  return (
    <div className={classes.tooltipWrapper}>
      {children}
      <div className={classes.tooltip}>{text}</div>
    </div>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string,
}
